import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import {
  AuthState,
  User,
  login,
  googleAuthLogin,
  updateToken,
  logout,
  updateUser,
  fetchUserRequest,
  fetchUserFailure,
  initializeAuthComplete,
} from '../types';

// No localStorage hydration - tokens are now stored in memory only
// Initial auth check happens via refresh token cookie in ProtectedRoute
const initialAuthState: AuthState = {
  user: null,
  isAuthenticated: false,
  accessToken: null,
  isUserLoading: false,
  isInitializing: true, // True until initial refresh attempt completes
};

export const authReducer = createReducer(initialAuthState, (builder) => {
  builder
    .addCase(fetchUserRequest, (state) => {
      state.isUserLoading = true;
    })
    .addCase(login, (state, action: PayloadAction<User>) => {
      state.user = action.payload;
      state.isAuthenticated = true;
      state.isUserLoading = false;
    })
    .addCase(googleAuthLogin, (state, action: PayloadAction<User>) => {
      state.user = action.payload;
      state.isAuthenticated = true;
      state.isUserLoading = false;
    })
    .addCase(updateToken, (state, action: PayloadAction<string>) => {
      state.accessToken = action.payload;
      state.isAuthenticated = Boolean(action.payload);
    })
    .addCase(fetchUserFailure, (state) => {
      state.isUserLoading = false;
    })
    .addCase(logout, (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.accessToken = null;
      state.isUserLoading = false;
      state.isInitializing = false;
    })
    .addCase(updateUser, (state, action: PayloadAction<Partial<User>>) => {
      if (state.user) {
        state.user = { ...state.user, ...action.payload };
      }
    })
    .addCase(initializeAuthComplete, (state) => {
      state.isInitializing = false;
    });
});
